import React, { Component } from 'react'
import H1 from '../../components/H1'
import '../../styles/css/contact.css'

class Contact extends Component {

  constructor(props) {
    super(props)
    this.state = {
      message: {}
    }
  }

  handleInputChange = ({ target: { name,value } }) => {
    this.setState({
      message: {
        ...this.state.message,
        [name]: value
      }
    })
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.sendMessage(this.state.message)
    this.refs.form.reset()
  }

  render() {
    const section = { target: 'contact', title: 'Contact'}
    const { sent } = this.props
    return(
      <div className="contact">
        <div className="contact-content">
          <div className="contact-hero">
              
              <H1 section={section} />
              
              <form onSubmit={this.handleSubmit} ref="form">
                <label htmtfor="name" className="required">Name</label>
                <input onChange={this.handleInputChange} name="name" type="text" className="required" required/>
                
                <label htmtfor="email" className="required">E-mail</label>
                <input onChange={this.handleInputChange} name="email" type="email" required/>

                <label htmtfor="phone">Phone number</label>
                <input onChange={this.handleInputChange} name="phone" type="text"/>
                
                <label htmtfor="company">Company</label>
                <input onChange={this.handleInputChange} name="company" type="text"/>

                <label htmtfor="message" className="required">Your message</label>
                <textarea onChange={this.handleInputChange} name="message" rows="5" required></textarea>
                <button className={sent ? 'sent' : ''}>{sent ? 'Message has been sent.' : 'Send message'}</button>
              </form>

            </div>       
        </div>
      </div>
    )
  }

}

export default Contact



// WEBPACK FOOTER //
// ./src/containers/home/contact.js